/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import BaseApiService from './base-api-service';

export default class AdminService extends BaseApiService {
  publish = async () => {
    const result = await this.postResource('/Publish', {});

    return result;
  };

  uploadData = async (data: FormData) => {
    const result = await this.postResourceFormData('/UploadData/Daily_Market_Total', data);
    return result;
  };

  downloadPdf = async (data: any, ac?: AbortController) => {
    const result = await this.postResourceFullResponse('/downloadpdf', { ...data }, ac);

    return result;
  };
}
